var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFooterLineDetail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 844,
    height: 1266,
    viewBox: "0 0 844 1266"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E9E61F",
    strokeWidth: 2,
    d: "M421 842.976471C188.490443 842.976471 0 1031.46691 0 1263.97647L421 1263.97647 421 842.976471zM421 842.976471C421 610.466914 232.514536 421.976471 0 421.976471L0 842.976471 421 842.976471zM421 842.976471C653.509557 842.976471 842 654.491007 842 421.976471L421 421.976471 421 842.976471zM421 421.976471C421 189.466914 232.514536.976470588 0 .976470588L0 421.976471 421 421.976471z",
    transform: "translate(1 1.024)"
  })));
}

export default __webpack_public_path__ + "static/footer-line-detail-41617fe2f2b3e0495bd83a88bd749a5e.svg";
export { SvgFooterLineDetail as ReactComponent };